import { ref } from "vue"

export const useContextMenu = () => {
  const contentRef = ref()
  const showContextMenu = (x: number, y: number) => {
    contentRef.value.style.left = x + 'px'
    contentRef.value.style.top = y + 'px'
  }
  // 调整 x 和 y 的位置。因为 contextmenu 有可能在窗口外部。
  /**
 * 
 * @param {number} x 将要设置的菜单的左上角坐标 x
 * @param {number} y 左上角 y
 * @param {number} w 菜单的宽度
 * @param {number} h 菜单的高度
 * @returns {x, y} 调整后的坐标
 */
  const adjustPos = (x: number, y: number, w: number, h: number) => {
    const PADDING_RIGHT = 6  // 右边留点空位，防止直接贴边了，不好看
    const PADDING_BOTTOM = 6  // 底部也留点空位
    const vw = document.documentElement.clientWidth
    const vh = document.documentElement.clientHeight
    if (x + w > vw - PADDING_RIGHT) x -= w
    if (y + h > vh - PADDING_BOTTOM) y -= h
    return {x, y}
  }
  const onFileContextmenu = (text: string, e: MouseEvent) => {
    e.preventDefault()
    const rect = contentRef.value.getBoundingClientRect()
    const { x, y } = adjustPos(e.clientX, e.clientY, rect.width, rect.height)
    showContextMenu(x, y)
  }
  const hideContextMenu = () => {
    if(contentRef.value){
      contentRef.value.style.top = '99999px'
      contentRef.value.style.left = '99999px'
    }
  }
  document.body.addEventListener('click', hideContextMenu)
  return  { contentRef, onFileContextmenu }
}